<template>
<div>
	<v-data-table
		:headers="headers"
		:items="accommodations"
		hide-actions
		class="elevation-1"
	>
		<template slot="items" slot-scope="props">
			<td class="text-xs-left">
				{{ props.item.landlord ? props.item.landlord.landlord_name : '' }}
			</td>
			<td class="text-xs-left">
				{{ props.item.apartment_address ? props.item.apartment_address.cz_addr : '' }}
			</td>
			<td class="text-xs-left">{{ props.item.room_number }}</td>
			<td class="text-xs-left">{{ props.item.started_at }}</td>
			<td class="text-xs-left">{{ props.item.ended_at }}</td>
			<td class="text-xs-center actioons">
				<v-tooltip top>
					<v-btn slot="activator" fab dark small color="indigo lighten-2" @click="edit(props.item)">
						<v-icon dark>edit</v-icon>
					</v-btn>
					<span>{{$t('common.edit')}}</span>
				</v-tooltip>

				<ConfirmDialog v-bind="propConfirmDialog" @accept="onDelete(props.item.id)" :tooltip="$t('common.delete')">
					<v-icon dark>delete</v-icon>
				</ConfirmDialog>
			</td>
		</template>
	</v-data-table>
	<v-layout row justify-end>
		<Form v-bind="propForm" :landlords="landlords" @cancel="cancel" @open="open" @save="save"/>
	</v-layout>
</div>
</template>

<script>
import { mapActions } from 'vuex'
import {
	HEADERS_TABLE_ACCOMODATION,
	TEMPLATE_ACCOMMODATION,
} from '../../../../constants'
import ConfirmDialog from '../../../../components/ConfirmDialog'
import Form from './Form'
import { notify } from '../../../../utils/notifications'

import { localeHeadersWorkers } from '../../../../utils/helpers'

export default {
	created() {
		this.getLandlords({
			count: 100
		})
	},
	components: {
		ConfirmDialog,
		Form
	},
	data: vm => ({
		propForm: {
			formData: { ...TEMPLATE_ACCOMMODATION },
			dialog: false
		},
		headers: localeHeadersWorkers(HEADERS_TABLE_ACCOMODATION, vm.$t),
		propConfirmDialog: {
			message: vm.$t('worker.confirm_accommodation'),
			title: vm.$t('common.confirm'),
			btnProps: {
				fab: true,
				dark: true,
				small: true,
				color: 'red lighten-2'
			}
		}
	}),
	computed: {
		accommodations() {
			return this.$store.state.workers.workerDetail.accommodations
		},
		landlords() {
			return this.$store.state.landlords.list
		}
	},
	methods: {
		...mapActions({
			createAccommodation: 'workers/createAccommodation',
			updateAccommodation: 'workers/updateAccommodation',
			deleteAccommodation: 'workers/deleteAccommodation',
			getLandlords: 'landlords/fetch'
		}),
		cancel() {
			this.propForm.dialog = false
			this.propForm.formData = { ...TEMPLATE_ACCOMMODATION }
		},
		open() {
			this.propForm.dialog = true
		},
		save(item) {
			let func = this.createAccommodation
			let message = 'created'
			if (item.id > 0) {
				func = this.updateAccommodation
				message = 'updated'
			}
			if(item.apartment_address_data) {
				item.landlord_id = null
				item.apartment_address_id = null
			}
			func({ ...item }).then(() => {
				this.$notify({
					...notify,
					text: this.$t(`notifications.${message}`, { type: this.$t('workers.accommodation') })
				})
			})
			this.cancel()
		},
		edit(data) {
			this.setDataForm(data)
			this.open()
		},
		onDelete(id) {
			this.deleteAccommodation(id).then(() => {
				this.$notify({
					...notify,
					text: this.$t('notifications.deleted', { type: this.$t('workers.accommodation') })
				})
			})
		},
		setDataForm(data) {
			this.propForm.formData = { ...data }
		}
	}
}
</script>

<style scoped>
.actioons {
	display: flex;
}
</style>
